// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"Alert_messageContainer__Qa7UX","callToActionChildren":"Alert_callToActionChildren__WM24t","notice":"Alert_notice__zkL58"};